import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';

import type { LayoutBoardCard } from '@core/views-util';
import type { AskTicketBoardItem } from '@tellent-ask-hr/core-types';

import { AskTicketItemComponent } from '../../ask-ticket-item/ask-ticket-item.component';
import { AskTicketsDataSourceService } from '../ask-tickets-data-source.service';

@Component({
  selector: 'ask-ticket-board-item',
  imports: [CommonModule, AskTicketItemComponent],
  template: '<ask-ticket-item [ticket]="record"/>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'rt-card rt-card-clickable',
    '(click)': 'onClick()',
  },
})
export class AskTicketBoardItemComponent implements LayoutBoardCard<AskTicketBoardItem> {
  private readonly askTicketsDataSourceService = inject(AskTicketsDataSourceService);

  @Input() public record: LayoutBoardCard<AskTicketBoardItem>['record'];
  @Input() public fieldsVisibilityMap: LayoutBoardCard<AskTicketBoardItem>['fieldsVisibilityMap'];
  @Input() public isSelected: LayoutBoardCard<AskTicketBoardItem>['isSelected'];

  @Output() public select = new EventEmitter();

  public onClick() {
    this.askTicketsDataSourceService.onRecordClick(this.record);
  }
}
